import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { FilterModalComponent } from '../../../../shared/components/filter-modal/filter-modal.component';
import { ICampaign } from '../../../../shared/interfaces/i-campaign';
import { IFilter } from '../../../../shared/interfaces/i-filter';
import { WebappService } from '../../../../shared/services/webapp.service';

@Component({
  selector: 'mobo-campaign-list',
  templateUrl: './campaign-list.component.html',
  styles: [],
})
export class CampaignListComponent implements OnInit, OnDestroy {
  @ViewChild('filter') filterComponent!: FilterModalComponent;

  public baseUrl = environment.baseUrl;
  public campaigns?: ICampaign[];
  public filteredCampaigns?: ICampaign[];
  public filteredDelivery?: ICampaign[];
  public searchTerm: string = '';
  public filters: IFilter[] = [];

  constructor(public webappService: WebappService, private router: Router) {}

  ngOnInit(): void {
    this.webappService.campaigns.subscribe((campaigns) => {
      this.campaigns = campaigns;
      this.search(this.searchTerm);
    });
    this.watchCity();
  }

  ngOnDestroy() {
    this.clearFilter();
  }

  setCampaigns(campaigns: ICampaign[]) {
    this.filteredCampaigns = [...campaigns].filter((x) => !x.IsDelivery);
    this.filteredDelivery = [...campaigns].filter((x) => x.IsDelivery);
  }

  search(term: string = '') {
    this.searchTerm = term;
    let filtered = [...(this.campaigns || [])];
    if (this.searchTerm) {
      filtered = filtered.filter((x) => this.filteredCampaign(x, term));
    }
    this.setCampaigns(filtered);
  }

  filteredCampaign(campaign: ICampaign, term: string) {
    term = this.simplifyString(term);
    const params = [
      campaign.CommercialPlaceTradeName,
      campaign.Title,
      campaign.Description,
      ...campaign.Categories?.map((c) => c.Name),
    ].map((p) => this.simplifyString(p));
    return params.some((c) => c.includes(term));
  }

  simplifyString(str: string) {
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  addFilters(filters: IFilter[]) {
    this.filters = [...filters];
  }

  removeFilter(filter: IFilter) {
    this.filters = [...this.filters.filter((f) => f.id !== filter.id)];
    this.filterComponent.addFilters(filter);
  }

  searchFilters() {
    let categories = this.filters
      .filter((x) => x.type == 'CATEGORY')
      .map((x) => x.id)
      .join(',');
    let moments = this.filters
      .filter((x) => x.type == 'MOMENT')
      .map((x) => x.id)
      .join(',');
    this.webappService.searchCampaigns(categories, moments);
  }

  clearFilter() {
    this.addFilters([]);
    this.searchFilters();
    this.filterComponent.resetFilter();
  }

  watchCity() {
    this.webappService.selectedCity.subscribe(() => {
      this.addFilters([]);
      if (this.filterComponent) this.filterComponent.resetFilter();
    });
  }
}
